import { useState, useContext } from 'react'
import { LanguageContext } from '../../contexts/language'
import './Contact.css'

export default function Contact() {
  const { portfolio, t } = useContext(LanguageContext)
  const { contact } = portfolio
  const [result, setResult] = useState('')

  const onSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.target)
    formData.append('access_key', '91f8e75a-0fba-47ee-aa4b-4b18bc40d6ea')

    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    })

    const data = await response.json()
    // No need to set result twice in one branch
    if (data.success) {
      setResult(t.submitSuccess)
      event.target.reset()
    } else {
      setResult(t.submitError)
    }
  };

  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>{t.contact}</h2>
      <form onSubmit={onSubmit} className='contact__form'>
        <div className='contact__desc'>
          {contact.description && <p>{contact.description}</p>}
        </div>
        <input type='text' name='name' required placeholder={t.namePlaceholder} />
        <input type='email' name='email' required placeholder={t.emailPlaceholder} />
        <textarea name='message' required placeholder={t.messagePlaceholder} />
        <button type='submit' className='btn btn--outline contact__btn'>{t.submit}</button>
        <p>{result}</p>
      </form>
    </section>
  )
}
